define('shared/util/scriptInjector',[],function( ){

    function load( scriptContent ) {

        if ( 
            document.readyState == 'interactive' ||
            document.readyState == 'complete'
        ) {
            // document write here will be very dangerous...
            var container = document.createElement('div');
            container.innerHTML = scriptContent;
            container.style.display = 'none';

            document.body.appendChild(container);
        }
        else {
            document.write(scriptContent);
        }
    }

    return {
        load: load
    };
});
